import AnimatedSection from '../../../components/base/AnimatedSection';
import { useLang } from '../../../context/LanguageContext';

export default function MapSection() {
  const { t } = useLang();

  return (
    <section className="w-full bg-zinc-900 py-20 px-6">
      <div className="max-w-screen-xl mx-auto">
        <AnimatedSection>
          <div className="text-center mb-12">
            <span className="inline-block text-red-500 text-[10px] font-extrabold uppercase tracking-widest mb-4">
              {t('map_badge')}
            </span>
            <h2 className="text-white text-3xl md:text-4xl font-extrabold uppercase tracking-wider mb-4">
              {t('map_title')} <span className="text-red-500">{t('map_title_accent')}</span>
            </h2>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-stretch">
          {/* Info cards */}
          <AnimatedSection className="lg:col-span-2 flex flex-col gap-4">
            <div className="bg-zinc-800 border border-zinc-700 rounded-2xl p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-zinc-700 mb-4">
                <i className="ri-map-pin-2-fill text-red-500 text-lg" />
              </div>
              <p className="text-zinc-400 text-[10px] font-bold uppercase tracking-widest mb-2">{t('map_dir_label')}</p>
              <p className="text-white text-sm font-semibold leading-relaxed">
                C/Octavio Mejía Ricart Esq.<br />
                C/Aruba #18A, Ens. Ozama<br />
                Santo Domingo Este, RD
              </p>
              <a
                href="https://maps.app.goo.gl/fiVfv1yGkZk2UDSG6"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-1.5 text-red-500 hover:text-red-400 text-xs font-bold mt-3 transition-colors cursor-pointer"
              >
                {t('map_maps')}
                <i className="ri-external-link-line" />
              </a>
            </div>

            <div className="bg-zinc-800 border border-zinc-700 rounded-2xl p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-zinc-700 mb-4">
                <i className="ri-time-fill text-red-500 text-lg" />
              </div>
              <p className="text-zinc-400 text-[10px] font-bold uppercase tracking-widest mb-3">{t('map_hours_label')}</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-zinc-300 text-xs font-medium">{t('map_mon_sat')}</span>
                  <span className="text-white text-xs font-bold">9:00 AM – 6:00 PM</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-zinc-300 text-xs font-medium">{t('map_sun')}</span>
                  <span className="text-zinc-500 text-xs">{t('map_closed')}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-zinc-300 text-xs font-medium">{t('map_holidays')}</span>
                  <span className="text-zinc-500 text-xs">{t('map_closed')}</span>
                </div>
              </div>
            </div>

            <div className="bg-zinc-800 border border-zinc-700 rounded-2xl p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-zinc-700 mb-4">
                <i className="ri-phone-fill text-red-500 text-lg" />
              </div>
              <p className="text-zinc-400 text-[10px] font-bold uppercase tracking-widest mb-3">{t('map_contact_label')}</p>
              <div className="space-y-2">
                <a href="tel:8295961615" className="flex items-center gap-2 text-white text-sm hover:text-red-400 transition-colors cursor-pointer">
                  <i className="ri-phone-line text-zinc-600 text-xs" />
                  (829) 596-1615
                </a>
                <a href="tel:8492081166" className="flex items-center gap-2 text-white text-sm hover:text-red-400 transition-colors cursor-pointer">
                  <i className="ri-phone-line text-zinc-600 text-xs" />
                  (849) 208-1166
                </a>
                <a href="mailto:ventas@spartechrd.com" className="flex items-center gap-2 text-white text-sm hover:text-red-400 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-zinc-600 text-xs" />
                  ventas@spartechrd.com
                </a>
              </div>
            </div>
          </AnimatedSection>

          {/* Google Map */}
          <AnimatedSection className="lg:col-span-3" delay={200}>
            <div className="relative w-full h-full min-h-[420px] rounded-2xl overflow-hidden border border-zinc-700">
              <div className="absolute top-0 left-0 right-0 z-10 bg-gradient-to-b from-zinc-950/60 to-transparent h-12 pointer-events-none" />
              <iframe
                src="https://maps.google.com/maps?q=Calle+Octavio+Mejia+Ricart+18A+Ensanche+Ozama+Santo+Domingo+Este+Dominican+Republic&t=&z=16&ie=UTF8&iwloc=B&output=embed"
                className="w-full h-full min-h-[420px]"
                style={{ border: 0, filter: 'invert(0.9) hue-rotate(180deg) saturate(0.8)' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="SpartechRD RD ubicación"
              />
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
